import type { Odds as OddsType } from '@ps/isp-web-services-types';
import { OddsFormat } from '@ps/web-core-enums';
import React, { useContext } from 'react';
import { FormattedNumber } from 'react-intl';

import { OddsFormatContext } from '@swf/sports/providers/OddsFormatProvider';

export type Props = Partial<OddsType>;

const Odds: React.FC<Props> = (props) => {
  const { americanDisplayOdds, decimalDisplayOdds, fractionalDisplayOdds, trueOdds } = props;

  const { oddsFormat } = useContext(OddsFormatContext);
  const decimal = decimalDisplayOdds?.decimalOdds ?? trueOdds?.decimalOdds?.decimalOdds ?? 0;
  const { numerator, denominator } = fractionalDisplayOdds ??
    trueOdds?.fractionalOdds ?? { numerator: '0', denominator: '0' };
  const americanOddsInt = americanDisplayOdds?.americanOddsInt || americanDisplayOdds?.americanOdds;

  if (oddsFormat === OddsFormat.American && americanOddsInt) {
    return <>{americanOddsInt > 0 ? `+${americanOddsInt}` : `${americanOddsInt}`}</>;
  }

  if (oddsFormat === OddsFormat.Decimal) {
    return (
      <FormattedNumber
        style="decimal"
        minimumFractionDigits={2}
        maximumFractionDigits={2}
        value={decimal}
      />
    );
  }

  return <>{`${numerator}/${denominator}`}</>;
};

export { Odds };
